import {ProcessFlow} from '../models/process.flow/processFlow.model';
import {JobProcess} from '../models/process.flow/jobProcess.model';
import {JobProcessFlow} from '../models/process.flow/jobProcessFlow.model';
import {Checkpoint} from '../models/process.flow/checkpoint.model';
import {User} from '../models/users/user.model';

export namespace ProcessFlows {
  export class GetProcessFlows {
    static readonly type = '[Process Flow api] Get Process Flows';

    constructor(public force: boolean = false) {
    }
  }

  export class GetProcessFlow {
    static readonly type = '[Process Flow api] Get Process Flow';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateProcessFlow {
    static readonly type = '[Process Flow api] Create Process Flow';

    constructor(public processFlow: ProcessFlow) {
    }
  }

  export class UpdateProcessFlow {
    static readonly type = '[Process Flow api] Update Process Flow';

    constructor(public processFlow: ProcessFlow) {
    }
  }

  export class DeleteProcessFlow {
    static readonly type = '[Process Flow api] Delete Process Flow';

    constructor(public processFlow: ProcessFlow) {
    }
  }

  export class GetJobProcessFlows {
    static readonly type = '[Process Flow api] Get Job Process Flows';

    constructor(public force: boolean = false) {
    }
  }

  export class GetJobProcessFlow {
    static readonly type = '[Process Flow api] Get Job Process Flow';

    constructor(public jobId: string, public id: string, public force: boolean = false) {
    }
  }

  export class GetMyProcesses {
    static readonly type = '[Process Flow api] Get My Processes';

    constructor(public force: boolean = false) {
    }
  }

  export class SelectMyCurrentProcess {
    static readonly type = '[Process Flow api] Select My Current Processes';

    constructor(public process: JobProcess) {
    }
  }

  export class SignOffProcess {
    static readonly type = '[Process Flow api] Sign off process';

    constructor(public process: JobProcess) {
    }
  }

  export class GetNextProcess {
    static readonly type = '[Process Flow api] Get Next process';

    constructor() {
    }
  }

  export class StartProcess {
    static readonly type = '[Process Flow api] Start process';

    constructor(public process: JobProcess) {
    }
  }

  export class AssignProcess {
    static readonly type = '[Process Flow api] Assign process';

    constructor(public process: JobProcess, public user: User) {
    }
  }

  export class UpdateProcess {
    static readonly type = '[Process Flow api] Update process';

    constructor(public process: JobProcess, public checkpoints: Checkpoint[]) {
    }
  }
}
